import classNames from 'classnames'
import React from 'react'
import Title from '../Title'
import { PHOTOS_COUNT_FORMS } from '@/const'
import { countForm } from '../../utils'
import { GxIcon } from '@garpix/garpix-web-components-react'
import { arrowRightLongIcon } from '@/images'
import style from './styles/media.module.scss'

interface IProps {
  className?: string
  image: string
  title: string
  count: number
  date: string
  id: number
  baseUrl: string
}

const MediaPhotosCard = ({
  className = '',
  image,
  title,
  count,
  date,
  id,
  baseUrl
}: IProps): React.ReactElement => {
  const slicedDate = date.slice(0, 10)

  return (
    <a
      href={`${baseUrl}?section_id=${id}`}
      className={classNames({
        [style.photo]: true,
        [className]: Boolean(className)
      })}
      title={title}
    >
      <img
        src={image}
        width='560px'
        height='311px'
        alt={title}
        loading='lazy'
        className={style.photo__image}
      />
      <div className={style.photo_content}>
        <div className={style.photo_content_left}>
          <Title type='h3' theme='h5' className={style.photo__title}>
            {title}
          </Title>
          <span className={style.photo__count}>
            {`${count} ${countForm(count, PHOTOS_COUNT_FORMS)}`}
          </span>
        </div>
        <div className={style.photo_content_right}>
          <span className={style.photo__date}>{slicedDate}</span>
          <GxIcon src={arrowRightLongIcon} className={style.photo__icon} />
        </div>
      </div>
    </a>
  )
}

export default MediaPhotosCard
